/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

export class NoteModel {
  private _noteId?: string;
  private _noteHeading?: string;
  private _noteDetails?: string;
  private _ownerId?: string;
  private _archived?: boolean;
  private _createdDate?: Date;
  private _updatedDate?: Date;

  constructor(
    noteId?: string,
    noteHeading?: string,
    noteDetails?: string,
    ownerId?: string,
    archived?: boolean,
    createdDate?: Date,
    updatedDate?: Date
  ) {
    this._noteId = noteId;
    this._noteHeading = noteHeading;
    this._noteDetails = noteDetails;
    this._ownerId = ownerId;
    this._archived = archived;
    this._createdDate = createdDate;
    this._updatedDate = updatedDate;
  }

  public get noteId(): string {
    return this._noteId;
  }
  public set noteId(value: string) {
    this._noteId = value;
  }

  public get noteHeading(): string {
    return this._noteHeading;
  }

  public set noteHeading(noteHeading: string) {
    this._noteHeading = noteHeading;
  }

  public get noteDetails(): string {
    return this._noteDetails;
  }

  public set noteDetails(noteDetails: string) {
    this._noteDetails = noteDetails;
  }

  public get ownerId(): string {
    return this._ownerId;
  }

  public set ownerId(ownerId: string) {
    this._ownerId = ownerId;
  }

  public get archived(): boolean {
    return this._archived;
  }

  public set archived(archived: boolean) {
    this._archived = archived;
  }

  public get createdDate(): Date {
    return this._createdDate;
  }

  public set createdDate(createdDate: Date) {
    this._createdDate = createdDate;
  }

  public get updatedDate(): Date {
    return this._updatedDate;
  }

  public set updatedDate(updatedDate: Date) {
    this._updatedDate = updatedDate;
  }

  toJson(): Object {
    const object = {
      note_id: this.noteId,
      note_heading: this.noteHeading,
      note_details: this.noteDetails,
      owner_id: this.ownerId,
      archived: this.archived,
      created_date: this.createdDate,
      updated_date: this.updatedDate,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): NoteModel {
    return new NoteModel(
      input['note_id'],
      input['note_heading'],
      input['note_details'],
      input['owner_id'],
      input['archived'],
      input['created_date'],
      input['updated_date']
    );
  }
}
